export const DISTRIBUTOR_TYPE = {
  master: "master_distributor",
  sub: "sub_distributor",
};
